const urlSafeCharset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
export const randomUrlSafeBytes = (noBytes) => {
    const maxUnbiased = 256 - (256 % urlSafeCharset.length); // 248 for 62 chars
    const result = [];
    while (result.length < noBytes) {
        const buf = new Uint8Array(noBytes - result.length);
        crypto.getRandomValues(buf);
        for (const v of buf) {
            if (v < maxUnbiased && result.length < noBytes)
                result.push(urlSafeCharset[v % urlSafeCharset.length]);
        }
    }
    return result.join('');
};
